export default __webpack_public_path__ + "static/media/icone-linkedin-redondo-branco.685c8d3d.svg";